export default "__VITE_ASSET__35f65f9b__"